import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./services/firebase";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import store from "./store";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./Theme"; // Import GLOBAL Theme
import Router from "./routes/RouterContainer";
import ErrorBoundary from "./components/ui/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store.store}>
    <ThemeProvider theme={theme}>
      <PersistGate loading={null} persistor={store.persistor}>
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
      </PersistGate>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
